// 💾 src/pages/client/sections/Trades.tsx
import { useState } from "react"
import { addDoc, collection, serverTimestamp } from "firebase/firestore"
import { getAuth } from "firebase/auth"
import { getFirestore } from "firebase/firestore"
import TradingChart from "./components/trade/TradingChart"
import MarketSelector from "./components/trade/MarketSelector"
import OrderBook from "./components/trade/OrderBook"
import TradeForm from "../../../components/trade/TradeForm"
import RecentTrades from "../../../components/trade/RecentTrades"
import OpenOrders from "../../../components/trade/OpenOrders"
import { useUserTrades } from "../../../hooks/useUserTrades"



const auth = getAuth()
const db = getFirestore()

const Trades = () => {


  return (
    <div>
    </div>
  )
}

export default Trades
